var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":`captcha-element-${_vm._uid}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }